import React from "react";
import { useTranslation } from "react-i18next";
import { FiFileText } from "react-icons/fi";
import "./MainContent.css";

import HeroSection from "./HeroSection/HeroSection";
import RocketSection from "./RocketSection/RocketSection";
import ServicesSection from "./ServicesSection/ServicesSection";
import PartnersSection from "./PartnersSection/PartnersSection";
import GroupSection from "./GroupSection/GroupSection";
import TestimonialsSection from "../TestimonialsSection/TestimonialsSection";
import ClubPage from "../ClubPage/ClubPage";
import NewsletterSection from "../NewsletterSection/NewsletterSection";

import ContactForm from "../ContactForm";
import TeamSection from "../TeamSection/TeamSection";
import Chapter from "../Chapter/Chapter";
import Faq from "../Faq/Faq";
import Cgv from "../Cgv/Cgv";

import RightPanel from "../RightPanel/RightPanel";

function MainContent({ onScroll, activeTab, setActiveTab, isScrolled }) {
  const { i18n } = useTranslation();
  const isEn = i18n.language?.startsWith("en");

  const renderContent = () => {
    if (activeTab === "join-club") {
      return (
        <div className="main-content-container" onScroll={onScroll}>
          <ClubPage setActiveTab={setActiveTab} />
        </div>
      );
    }
    if (activeTab === "team") {
      return <TeamSection />;
    }

    if (activeTab === "chapter") {
      return <Chapter onScroll={onScroll} />;
    }
    if (activeTab === "faq") {
      return <Faq onScroll={onScroll} />;
    }
    if (activeTab === "cgv") {
      return (
        <div className="main-content-container" onScroll={onScroll}>
          <Cgv />
        </div>
      );
    }
    if (activeTab === "news") {
      return (
        <div style={{ width: "100%", height: "100%", paddingBottom: "100px" }}>
          <RightPanel onScroll={onScroll} />
        </div>
      );
    }
    return (
      <div className="home-content">
        <HeroSection setActiveTab={setActiveTab} />
        <RocketSection />
        <ServicesSection />
        <TestimonialsSection />

        <PartnersSection />
        <GroupSection />
        <NewsletterSection />
        <section id="contact-section">
          <ContactForm />
        </section>
        <div className="legal-footer-note">
          <button
            type="button"
            className="legal-footer-btn"
            onClick={() => setActiveTab("cgv")}
          >
            <FiFileText />
            {isEn ? "Terms & Conditions (CGV)" : "Conditions générales d'adhésion (CGV)"}
          </button>
        </div>
        <div style={{ height: "50px" }}></div>
      </div>
    );
  };

  return (
    <main
      className={`main-content glass-panel ${isScrolled ? "expanded" : ""}`}
      onScroll={onScroll}
    >
      {renderContent()}
    </main>
  );
}

export default MainContent;
